import { getAccountTypes } from '../sevices/accountTypeService';

export const getAccountTypesApi = (token) => async (dispatch) => {
    await dispatch(getAccountTypes(token, dispatch))
};